// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.menu-item-text {
  color: #fff;
  font-size: 14px;
  flex-shrink: 1;
  align-self: center;
}

a:hover {
  color: var(--theme-active-alternate-color, #055C8D);
}

.menu-header-item-icon {
  color: #fff;
  font-size: 16px;
  font-family: Inter !important;
  align-self: center;
  vertical-align: middle;
  font-weight: bold;
}

.accordian-button-text {
  color: #fff !important;
  font-size: 16px !important;
  font-weight: normal !important;
  height: -moz-fit-content;
  height: fit-content;
  min-height: 24px;
  text-decoration: none !important;
}

.organisation-suspended::after {
  content: " (suspended)";
}

.card-header {
  padding-left: 5px !important;
  padding-right: 5px !important;
}

.card-body {
  padding-top: 5px !important;
  padding-bottom: 5px !important;
  padding-right: 0 !important;
  padding-left: 5px !important;
  position: relative;
}

.menu-header-item-text {
  color: var(--theme-active-alternate-color, #dedcdc);
  font-size: 17px;
  font-family: Inter !important;
  align-self: center;
  vertical-align: middle;
  font-weight: bold;
  margin-left: 10px;
}

.icon-gap {
  margin-left: 10px;
  display: flex;
  height: 100%;
  min-height: 0;
  align-self: baseline;
}

.vertical-align {
  margin-bottom: auto;
  margin-top: auto;
}

.header-row {
  border-bottom: 1px solid rgb(236, 236, 236);
  align-content: center;
  padding-left: 10px;
  flex-basis: 64px;
  min-height: 64px;
}

.add-organisation-row {
  border-top: 1px solid rgb(236, 236, 236);
  padding-right: 5px;
  flex-basis: 32px;
  min-height: 32px;
}

.logout-row {
  border-top: 1px solid rgb(236, 236, 236);
  justify-content: left;
  padding-left: 5px;
  padding-right: 5px;
  flex-basis: 40px;
  min-height: 40px;
}

.apply-org-row {
  border-top: 1px solid rgb(236, 236, 236);
  justify-content: center;
  padding-left: 5px;
  padding-right: 5px;
}

.menu-row {
  flex-shrink: 1;
  flex-grow: 1;
  padding-left: 5px;
  padding-right: 5px;
}

.add-organisation-link {
  text-align: center;
  color: white;
  cursor: pointer;
}

.add-organisation-link-text {
  text-align: center;
  color: white;
  cursor: pointer;
  margin-left: 10px;
}

.logo-background-color {
  background-color: var(--theme-logo-background-color, #055C8D);
}

.logout-link {
  text-decoration: none;
  background-color: #fff;
  border-radius: 5px;
  border: 1px solid var(--theme-main-border-color, #055C8D);
  margin-top: 5px;
  margin-bottom: 5px;
  padding-left: 1.5vw;
  padding-right: 1.5vw;
  padding-top: 3px;
  padding-bottom: 4px;
  text-align: center;
  font-family: Inter;
  font-size: 13px;
  font-weight: 600;
  color: var(--theme-main-color, #055C8D);
  cursor: pointer;
}

.logout-link:hover {
  text-decoration: none;
  background-color: var(--theme-active-color, #055C8D);
  border-radius: 5px;
  border: 1px solid #fff;
  margin-top: 5px;
  margin-bottom: 5px;
  padding-left: 1.5vw;
  padding-right: 1.5vw;
  padding-top: 3px;
  padding-bottom: 4px;
  text-align: center;
  font-family: Inter;
  font-size: 13px;
  font-weight: 600;
  color: #fff;
  cursor: pointer;
}

.content-panel {
  overflow-y: auto;
  min-height: 0;
}

.settings-icon {
  color: white;
}

.las {
  font-size: 17px;
}

.organisation-modules-settings {
  height: 93%;
  overflow-x: hidden;
  overflow-y: scroll;
}

.menu-item {
  padding-left: 28px;
}

.organisation-line {
  color: white;
  background-color: white;
  width: 100%;
}

.bottom-group {
  position: absolute;
  bottom: 4%;
  width: 229.63px;
}

.bottom-group-line {
  background-color: white;
  width: 100%;
}

.link-spacer {
  margin-top: 1%;
  margin-bottom: 1%;
}

.row-item {
  padding-top: 15px;
  padding-bottom: 15px;
}

.padded-menu-item {
  padding-left: 5%;
  padding-top: 2px;
  padding-bottom: 2px;
}

.icon {
  color: white;
  float: right;
}

.menu-item-module {
  padding-left: 40px;
}

.tool-map {
  bottom: 1%;
  position: absolute;
  width: 100%;
}

.keyboard-backspace {
  vertical-align: top;
  color: white;
}

.organisation-setting-icon {
  display: none;
  width: 10%;
}

.organisation-setting-label {
  font-weight: bold;
  padding-right: 0;
  padding-left: 0;
}

.user-organisations {
  overflow-y: scroll;
  height: 40%;
}

.module-item {
  width: 85%;
  margin-left: 5%;
}

.icon-button {
  padding: 0;
  min-width: 0;
  width: 20px;
  height: 20px;
  flex-shrink: 0;
  line-height: 20px;
  color: white;
  border-style: none;
  border-color: var(--theme-main-border-color, #055C8D);
}

.icon-header-button {
  cursor: pointer;
  font-size: 26px;
  vertical-align: middle;
}

.dropdown-content {
  display: block;
  position: absolute; /* new */
  width: 100%; /* new */
}

.module-item-icon-column {
  flex-basis: 24px;
  min-width: 24px;
  max-width: 24px;
  padding-top: 5px;
  padding-bottom: 5px;
}

.module-item-column {
  flex-shrink: 1;
  flex-grow: 1;
  padding-left: 5px;
  padding-top: 5px;
  padding-bottom: 5px;
  cursor: pointer;
}

.add-org {
  padding-left: 5px;
}

.module-suspended::after {
  content: " (suspended)";
}

.border-bottom {
  border-bottom: 5px solid red;
}

.municipalityheader {
  font-size: 18px;
  font-weight: 500;
}

.float-right {
  float: right !important;
}`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
